import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Button, Form, Modal } from 'react-bootstrap';

const RolesAdmin = () => {
  const [roles, setRoles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    role_name: ''
  });
  const [selectedRole, setSelectedRole] = useState(null);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const response = await axios.get('https://api.biznetusa.com/api/get-roles');
      setRoles(response.data.roles || []);
    } catch (error) {
      console.error('Error fetching roles:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddRole = async () => {
    try {
      const payload = {
        role_name: formData.role_name
      };

      const response = await axios.post('https://api.biznetusa.com/api/store-role', payload);
      fetchRoles(); // Fetch updated roles after adding a role
      setShowModal(false);
    } catch (error) {
      console.error('Error adding role:', error);
      if (error.response) {
        console.error('Backend error message:', error.response.data);
      }
    }
  };

  const handleUpdateRole = async () => {
    try {
      const payload = {
        role_name: formData.role_name
      };

      const response = await axios.put(`https://api.biznetusa.com/api/update-role/${selectedRole.id}`, payload);
      fetchRoles(); // Fetch updated roles after updating a role
      setShowModal(false);
    } catch (error) {
      console.error('Error updating role:', error);
      if (error.response) {
        console.error('Backend error message:', error.response.data);
      }
    }
  };

  const handleDeleteRole = async (id) => {
    try {
      await axios.delete(`https://api.biznetusa.com/api/deleterole/${id}`);
      fetchRoles();
    } catch (error) {
      console.error('Error deleting role:', error);
    }
  };

  const handleOpenModal = (role = null) => {
    if (role) {
      setSelectedRole(role);
      setFormData({
        role_name: role.role_name
      });
    } else {
      setFormData({
        role_name: ''
      });
      setSelectedRole(null);
    }
    setShowModal(true);
  };

  return (
    <div className='px-2 py-3'>
      <h2>Manage Roles</h2>
      <Button onClick={() => handleOpenModal()}>Add Role</Button>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Role Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {roles.length > 0 ? (
            roles.map(role => (
              <tr key={role.id}>
                <td>{role.id}</td>
                <td>{role.role_name}</td>
                <td>
                  <Button variant="warning" onClick={() => handleOpenModal(role)}>Edit</Button>
                  <Button variant="danger" onClick={() => handleDeleteRole(role.id)}>Delete</Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No roles found</td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedRole ? 'Edit Role' : 'Add Role'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formRoleName">
              <Form.Label>Role Name</Form.Label>
              <Form.Control
                type="text"
                name="role_name"
                value={formData.role_name}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
          <Button variant="primary" onClick={selectedRole ? handleUpdateRole : handleAddRole}>
            {selectedRole ? 'Update' : 'Add'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RolesAdmin;
